var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-client-table", {
    ref: "clientTable",
    staticClass: "drip-campaign-table table-clients vue-custom-table w-100",
    attrs: {
      id: "drip-campaign-table",
      data: _vm.campaigns || [],
      columns: _vm.columns,
      options: _vm.options,
    },
    scopedSlots: _vm._u([
      {
        key: "name",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-auto d-md-block d-none" }, [
                _c("div", { staticClass: "px-lg-2 px-1" }, [
                  _c("img", {
                    staticClass: "img-fluid rounded-circle lg",
                    attrs: {
                      src: require("@Shared/assets/img/email.png"),
                      alt: _vm.$tc("global.words.email", 1),
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col align-self-center" }, [
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "bold text-primary",
                          attrs: {
                            to: _vm._f("dripCampaignEditLink")(row.campaignId),
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(row.name) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "small text-uppercase" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("global.actions.lastEdited")) +
                        ":\n            "
                    ),
                    _c(
                      "b",
                      [
                        _c("refreshable-timeago", {
                          attrs: { date: row.updatedAt },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "profile-avatar",
                        _vm._b(
                          {
                            staticClass: "client-avatar mr-2",
                            staticStyle: { width: "1.5rem", height: "1.5rem" },
                          },
                          "profile-avatar",
                          row.createdBy,
                          false
                        )
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("fullName")(row.createdBy)) +
                            "\n            "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        },
      },
      {
        key: "active",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("drip-campaign-active-toggle", {
              attrs: {
                "campaign-id": row.campaignId,
                "email-id": row.emailId || "",
                active: row.active,
              },
            }),
          ]
        },
      },
      {
        key: "numOfEmails",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("div", { staticClass: "small" }, [
              _vm._v(
                "\n      " +
                  _vm._s(row.numOfStages) +
                  " " +
                  _vm._s(_vm.$tc("global.words.email", row.numOfStages)) +
                  "\n    "
              ),
            ]),
          ]
        },
      },
      {
        key: "numOfClients",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("div", { staticClass: "d-md-block d-none" }, [
              _c("p", { staticClass: "small m-0" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(row.numOfClients) +
                    "\n        " +
                    _vm._s(_vm.$tc("global.doorr.client", row.numOfClients))
                ),
                _c("br"),
                _vm._v(" "),
                _c("small", { staticClass: "text-primary text-uppercase" }, [
                  _c("i", [
                    _vm._v(
                      _vm._s(
                        "(+" +
                          row.numOfClientsSinceLastWeek +
                          " " +
                          _vm.$t("drip-campaigns.messages.sinceLastWeek") +
                          ")"
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        },
      },
      {
        key: "actions",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("button-bar", {
              staticClass: "no-gutters",
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-row justify-content-end",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-white mr-2",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleShowClients(row.campaignId)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "drip-campaigns.actions.viewClients"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-sm btn-primary",
                                attrs: {
                                  to: _vm._f("dripCampaignEditLink")(
                                    row.campaignId
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "drip-campaigns.actions.editCampaign"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "dropdown-content",
                    fn: function () {
                      return [
                        _c(
                          "b-dropdown-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.handleShowClients(row.campaignId)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("drip-campaigns.actions.viewClients")
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-link",
                                attrs: {
                                  to: _vm._f("dripCampaignEditLink")(
                                    row.campaignId
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "drip-campaigns.actions.editCampaign"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }